// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"607":"eb550fe6","668":"eb550fe6"}[chunkId] + ".chunk.css";
};